import { addToCart, clearCart, removeFromCart, updateQuantity } from "../actions/cart/actionCreators";

export function addToCartThunk(payload: Product) {
    return (dispatch: any) => dispatch(addToCart(payload))
}

export function clearCartThunk() {
    return (dispatch: any) => dispatch(clearCart())
}

export function removeFromCartThunk(payload: Product) {
    return (dispatch: any) => dispatch(removeFromCart(payload))
}

export function updateQuantityThunk(product: Product, quantity: number) {
    return (dispatch: any) => dispatch(updateQuantity({ product, quantity }))
}